const RESET_STEP_5_GLOBAL_STATE = 'RESET_STEP_5_GLOBAL_STATE';
const SET_STEP5_EMPLOYEES_IN_POOL = 'SET_STEP5_EMPLOYEES_IN_POOL';

export default {
  RESET_STEP_5_GLOBAL_STATE,
  SET_STEP5_EMPLOYEES_IN_POOL
}